import React, { useContext, useState, useEffect, useRef } from 'react';
import { Input, Form, Select, message } from 'antd';
import { FormInstance, Rule } from 'antd/lib/form';
import { ISelectOption } from '../YhFormBox/Types';

const EditableContext = React.createContext<FormInstance<any> | null>(null);

//tr 行信息
export interface Item {
    [key: string]: string | number | boolean | undefined | object
}

//表单类型
type IEditType = "input" | "select";
interface EditableRowProps {
    index: number;
}

//键码
enum IKeysCode {
    up = 38,
    down = 40,
    tab = 9
}

export const EditableRow: React.FC<EditableRowProps> = ({ index, ...props }) => {
    const [form] = Form.useForm();
    return (
        <Form form={form} component={false}>
            <EditableContext.Provider value={form}>
                <tr {...props} />
            </EditableContext.Provider>
        </Form>
    );
};

interface EditableCellProps {
    colIndex: number,
    rowIndex: number,
    editType?: IEditType;
    rules?: Rule[]
    title: React.ReactNode;
    options?: ISelectOption[]
    editable: boolean;
    children: React.ReactNode;
    dataIndex: keyof Item;
    suffix?: string,
    record: Item;
    allowClear: boolean,
    mode: "multiple" | "tags" | undefined,
    handleSave: (record: Item) => void;
    onSelectChange?: (value: string, options: ISelectOption, record: Item) => void;
    onSelectFocus?: (record: Item) => void
}

export const EditableCell: React.FC<EditableCellProps> = ({
    colIndex, //第几列下标
    rowIndex, //第几行下标
    editType = "input",
    options,
    rules,
    title,
    editable,
    children,
    dataIndex,
    record,
    suffix = "",
    allowClear=false,
    mode = undefined,
    onSelectChange,
    onSelectFocus,
    handleSave,
    ...restProps
}) => {
    const [editing, setEditing] = useState(false);
    const inputRef = useRef<Input>(null);
    const form = useContext(EditableContext)!;

    useEffect(() => {
        if (editing && editType === "input") {
            inputRef.current?.focus();
            inputRef.current?.select();
        }
    }, [editing]);

    const toggleEdit = () => {
        setEditing(!editing);
        form.setFieldsValue({ [dataIndex]: record[dataIndex] });
    };

    const save = async () => {
        try {
            const values = await form.validateFields();
            toggleEdit();
            handleSave({ ...record, ...values });
        } catch (errInfo) {
            console.log('Save failed:', errInfo);
        }
    };

    //监听键盘事件
    const onKeyDown = (e: any) => {
        // debugger;
        let rowNum = rowIndex + 1;  //当前行数
        let keyCode = e.keyCode;  //键码
        let tbodyChildren = e.target?.closest("tbody").children;  //当前所有的tr 行
        let trLength = tbodyChildren.length - 1;  //减去表头哪一行，所有tr数量

        //上键
        if (keyCode === IKeysCode.up) {
            e.preventDefault();
            e.returnValue = true;
            let isPrev = rowNum <= 1;
            // if (isPrev) {
            //     message.success("没有上一行");
            //     return;
            // }
            tbodyChildren[isPrev ? trLength : rowNum - 1].children[colIndex].children[0].click();

            //下键
        } else if (keyCode === IKeysCode.down) {
            e.preventDefault();
            let isNext = rowNum < trLength;
            // if (!isNext) {
            //     message.success("没有下一行");
            //     return;
            // }
            // console.log(tbodyChildren[isNext ? rowNum + 1 : 1].children,tbodyChildren)
            tbodyChildren[isNext ? rowNum + 1 : 1].children[colIndex].children[0].click();

            //tab切换
        } else if (keyCode === IKeysCode.tab) {

            e.preventDefault();
            let tdAll = tbodyChildren[rowNum]?.children;  //当前行所有列数；
            let numArr: number[] = [];        //记录input输入框所有td的下标
            for (let i = 0; i < tdAll.length ?? 0; i++) {
                tdAll[i].getAttribute("data-type") === "yh-input" && numArr.push(i);
            }
            let findIndex = numArr.findIndex(item => item === colIndex); //查找处于第几个

            if (!numArr.length) { return }
            if (findIndex === numArr.length - 1) {  //最后一个，直接到第一个。否则下一个
                tdAll[numArr[0]].children[0].click();
            } else {
                tdAll[numArr[findIndex + 1]].children[0].click();
            }
        }
    }
    let childNode = children;

    const inputTypes = () => {
        switch (editType) {
            case "input":
                return <Input
                    ref={inputRef}
                    // onPressEnter={save}
                    onBlur={save}
                    suffix={suffix}
                    onKeyDown={onKeyDown}
                />
            case "select":
                return <Select
                    showSearch
                    optionFilterProp="label"
                    ref={inputRef}
                    onBlur={save}
                    onSelect={(value: string, option) => { onSelectChange?.(value, option as ISelectOption, record) }}
                    onFocus={() => onSelectFocus?.(record)}
                    options={options ?? []}
                    allowClear={allowClear}
                    mode={mode}
                />
            default:
                return <></>
        }
    }
    if (editable) {
        childNode = editing ? (
            <Form.Item
                style={{ margin: 0 }}
                name={dataIndex}
                rules={rules}
            >
                {inputTypes()}
            </Form.Item>
        ) : (
                <div className={`editable-cell-value-wrap`} style={{ paddingRight: 24 }} onClick={toggleEdit}>
                    {children}
                </div>
            );
    }

    return <td {...restProps} data-type={`${editable ? `yh-${editType}` : ""}`}>{childNode}</td>;
};